module.exports = __webpack_public_path__ + "img/19.0bfff94a.jpg";